module.exports = __webpack_public_path__ + "img/attend.cc899bd6.jpg";